import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["chevron", "drill", "button"]

  toggle() {
    const expanded = this.buttonTarget.getAttribute("aria-expanded") === "true"
    this.buttonTarget.setAttribute("aria-expanded", !expanded)
    this.drillTarget.classList.toggle("grid-rows-[1fr]", !expanded)
    this.drillTarget.classList.toggle("grid-rows-[0fr]", expanded)
    this.chevronTarget.classList.toggle("rotate-90", !expanded)
  }

  showAll(event) {
    const tailId = event.currentTarget.dataset.tailId
    const tail = document.getElementById(tailId)
    if (tail) {
      tail.classList.remove("grid-rows-[0fr]")
      tail.classList.add("grid-rows-[1fr]")
    }
    event.currentTarget.remove()
    event.stopPropagation()
  }
}
